"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _dropdown = _interopRequireDefault(require("../dropdown"));

var _listSelect = _interopRequireDefault(require("./list-select"));

var _components = require("./components");

var _listItem = _interopRequireDefault(require("./list-item"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var propTypes = {
  activeGlyph: (0, _propTypes.oneOfType)([_propTypes.func, _propTypes.node, _propTypes.object]),
  activeValue: _propTypes.string,
  containerProps: (0, _propTypes.objectOf)((0, _propTypes.oneOfType)([_propTypes.array, _propTypes.string, _propTypes.number])),
  itemTag: _propTypes.node,
  items: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
    label: _propTypes.string,
    value: _propTypes.string
  })),
  listTitle: _propTypes.string,
  onChangeHandler: _propTypes.func,
  searchIcon: _propTypes.node,
  title: (0, _propTypes.oneOfType)([_propTypes.object, _propTypes.string]),
  titleTag: _propTypes.node
};
var labelFontObject = {
  color: "body-grey",
  fontSize: 0,
  fontWeight: 1,
  letterSpacing: "1.5px",
  lineHeight: 1
};

var ListDropdown = function ListDropdown(_ref) {
  var activeGlyph = _ref.activeGlyph,
      activeValue = _ref.activeValue,
      containerProps = _ref.containerProps,
      _ref$itemTag = _ref.itemTag,
      ItemTag = _ref$itemTag === void 0 ? _listItem["default"] : _ref$itemTag,
      _ref$titleTag = _ref.titleTag,
      TitleTag = _ref$titleTag === void 0 ? _components.DropdownTitle : _ref$titleTag,
      items = _ref.items,
      listTitle = _ref.listTitle,
      onChangeHandler = _ref.onChangeHandler,
      searchIcon = _ref.searchIcon,
      title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement(_dropdown["default"], {
    containerProps: Object.assign({
      mt: 1
    }, containerProps),
    render: function render(_ref2) {
      var show = _ref2.show;
      return /*#__PURE__*/_react["default"].createElement(TitleTag, {
        searchIcon: searchIcon,
        show: show
      }, title);
    },
    renderDropdown: function renderDropdown(_ref3) {
      var firstRef = _ref3.firstRef,
          returnFocus = _ref3.returnFocus,
          show = _ref3.show,
          toggleShowDropdown = _ref3.toggleShowDropdown;
      return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
        py: 2,
        width: 1
      }, listTitle && /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
        position: "relative",
        px: 3,
        py: 12
      }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
        alignItems: "center",
        justifyContent: "space-between"
      }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, labelFontObject, listTitle))), /*#__PURE__*/_react["default"].createElement(_listSelect["default"], {
        activeGlyph: activeGlyph,
        activeValue: activeValue,
        firstRef: firstRef,
        itemClickHandler: onChangeHandler,
        items: items,
        renderItem: function renderItem(isActive, isMouseOver, item) {
          return /*#__PURE__*/_react["default"].createElement(ItemTag, {
            activeGlyph: activeGlyph,
            isActive: isActive,
            isMouseOver: isMouseOver,
            item: item
          });
        },
        returnFocus: returnFocus,
        show: show,
        toggleShowDropdown: toggleShowDropdown
      }));
    }
  });
};

ListDropdown.propTypes = propTypes;
ListDropdown.displayName = "Modules.SearchDropdown";
var _default = ListDropdown;
exports["default"] = _default;